import { useMemo } from "react"
import { ReactComponent as Dashboard1Icon } from 'assets/icons/Dashboard1.svg';
import { ReactComponent as Dashboard2Icon } from 'assets/icons/Dashboard2.svg';
import { ReactComponent as Dashboard3Icon } from 'assets/icons/Dashboard3.svg';
import { ReactComponent as Dashboard4Icon } from 'assets/icons/Dashboard4.svg';

const useHomeItems = () => {

    const homeItems = useMemo(
        () => [
            {
                label: "תלמידים",
                icon: Dashboard1Icon,
                description: "מספר התלמידים שיש לכם במערכת והוספת תלמיד חדש."
            },
            {
                label: "מבדקים",
                icon: Dashboard2Icon,
                description: "מספר המבדקים המחכים לביצוע ומעבר אליהם."
            },
            {
                label: "דוחות",
                icon: Dashboard3Icon,
                description: "מספר הדוחות החדשים המחכים לכם ומעבר אליהם."
            },
            {
                label: "התקדמות",
                icon: Dashboard4Icon,
                description: "המלצה למעקב התקדמות ומעבר לקניית מבדק."
            }
        ], []
    )

    return homeItems
}

export default useHomeItems